import { phoneDisplay, phoneHref } from "@/data/products";

export default function Footer() {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <span>© {new Date().getFullYear()} AHUJA BROTHERS<sup>®</sup> · SINCE 1967 · LOHA MANDI, NARAINA, NEW DELHI</span>
      <a href={phoneHref()} className="footer-phone" data-testid="footer-phone-link">
        {phoneDisplay()}
      </a>
    </footer>
  );
}
